import React from 'react';
import './OrnateBackground.css';

function OrnateBackground({ children }) {
  return (
    <div className="ornate-container">
      <img
        src="/images/svg/container_shape.svg"
        alt=""
        className="ornate-svg"
      />
      <div className="ornate-content">
        {children}
      </div>
    </div>
  );
}

export default OrnateBackground;
